<script>
  import { apiCatalogue } from "../stores/stores";
  import Icon from './Icon.svelte';
  import { params } from '@sveltech/routify';

</script>

<div class="sidebar">
  <div class="heading">
    <Icon type="book" size="16" />
    <h3>APIs</h3>
  </div>
  {#each $apiCatalogue as api}
    <div class="item" class:active={$params.id === api.id}>
      <a href="/api/{api.id}">{api.title}</a>
    </div>
  {/each}
</div>

<style type="text/scss">
  @mixin active($bg-color, $color) {
    background-color: $bg-color;
    transition: background-color 0.3s ease;
    cursor: pointer;

    & > a {
      color: $color;
    }
  }

  .sidebar {
    height: 100%;
    background-color: white;
    border-right: solid 1px $offWhite;

    .heading {
      display: flex;
      align-items: center;
      padding: 10px 5px 10px 20px;
      margin: 0 10px;
      border-bottom: 1px solid $offWhite2;

      h3 {
        padding-left: 5px;
      }
    }

    .item {
      & > a {
        display: block;
        font-size: 15px;
        padding: 10px 10px 10px 30px;
        text-decoration: none;
      }

      &:hover {
        @include active($ciWashedBlue, black);
      }
    }

    .active {
      @include active($ciWashedBlue2, black);
    }
  }
</style>
